import { AxiosResponse, AxiosError } from "axios";
import { prepareError } from "../../../utils/error";
import api from "../../../data/api";
import { OptionCl } from "../../../components/select-cl";
import { Dispatch } from "redux";
//import { Currency } from "../../openapi/currency/api"

export const CASH_CORRESPONDENT_DOMAIN = "CASH_CORRESPONDENT"

export type CashCorr =  {
    name: string
}

const prepareCashCorrespondents  = ( response : CashCorr[]   ) => {
    const opts: OptionCl[] = response.map( (ccb : CashCorr) => ({
        id : ccb.name,
        description: ccb.name
    })
    )
    return opts;
}


// currencies for the dropdown
export const fetchCashCorrespondents = (
    dispatch : Dispatch<any>,
    componentType: "CcbCriteria" 
) => {
    //console.log("ismag criteria service getting data from /cities")
    api
        .post("/codelist/v1/ccb/cashcorrespondents")
        .then( (response:AxiosResponse) => {

            if (response.data && response.data.result === "ERROR") {
                dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(response.data) })
            } else { 
                //console.log("Cash correspondents domain service: got data " + JSON.stringify(response))
                const cities : CashCorr[] = response.data.CCB; 
                dispatch({type: componentType + "/DOMAINLOADED", payload: prepareCashCorrespondents(cities), domain: CASH_CORRESPONDENT_DOMAIN })
            }
        }).catch( (error:AxiosError) => {
            dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(error) })
        })

}
